import * as React from 'react';

import { useMediaCardData } from '~hooks'

import { MediaCard } from '~components/shared'

const Explore = ({props}) => {

  const { exploreArticles, exploreTitle } = props

  const articles = useMediaCardData()

  let topicsSection = []
  exploreArticles.forEach(article => {
    topicsSection.push(articles.find(({ contentful_id }) => contentful_id === article.contentful_id))
  })

  return (
    <div className="max-w-page">
      <div className="headline-section-centered mt-22">
        <div>{exploreTitle}</div>
      </div>

      {topicsSection.length > 0 && (
          <div className='flex flex-col lg:flex-row lg:justify-between lg:-mx-4 lg:mb-8'>
            {topicsSection.map(({ id, image, title, caption, url, type }) => (
              <div key={id} className='flex lg:w-1/2 lg:px-4'>
                <MediaCard image={image} title={title} url={url} type={type} fatherhoodCta className='mt-8' />
              </div>
            ))}
          </div>
        )
      }
    </div>
  )
}

export default Explore